import { SignInPage } from '@backstage/core-components';
import {
  createFrontendModule,
  microsoftAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import cloudhouseLogo from './nav/cloudhouse-logo-horizontal.png';

// Microsoft Entra ID is the only sign-in provider. `auto` redirects straight
// to Entra (no provider-picker), since there's no guest fallback in prod.
//
// The Cloudhouse logo replaces the banner title text on the sign-in page: the
// `ch-signin-page` wrapper hides the core Header title via CSS (see
// cloudhouse.css) and the logo is positioned over the banner in its place.
// SignInPage is left intact so the auth flow is unchanged.
const microsoftSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props) =>
      (
        <div className="ch-signin-page">
          <span className="ch-signin-logo">
            <img src={cloudhouseLogo} alt="Cloudhouse" />
          </span>
          <SignInPage
            {...props}
            auto
            provider={{
              id: 'microsoft-auth-provider',
              title: 'Microsoft',
              message: 'Sign in with your Cloudhouse account',
              apiRef: microsoftAuthApiRef,
            }}
          />
        </div>
      ),
  },
});

// pluginId 'app' + the sign-in-page blueprint id overrides the default
// (guest) sign-in page provided by @backstage/plugin-app.
export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [microsoftSignInPage],
});
